import { JOB_BUILDER_STEPS, type JobBuilderStep } from "@alm/domain";
import { optionalOneOf } from "@/lib/search";

/* Apart from the builder: two routes read `jobBuilderSearch` in validateSearch, and importing it
 * from job-builder.tsx pulled all the panels into the router's entry chunk. */
export const TABS = JOB_BUILDER_STEPS;

export type { JobBuilderStep };

/** The step lives in the URL: saving a new posting remounts the builder at the job's own URL, and
 * landing back on step one would lose place. */
export const jobBuilderSearch = (search: Record<string, unknown>): { step?: JobBuilderStep } => ({
  step: optionalOneOf(
    TABS.map((entry) => entry.value),
    search.step,
  ),
});
